import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header, Table } from 'semantic-ui-react'
import { IVehicle } from '@cbgms/api'
import VehicleMakeImage from 'app/vehicles/components/DashboardDetails/VehicleMakeImage.Semantic'
import { FuelType } from '@cbgms/api/modules/enums'
import { VinText } from '@carsys/ui'
interface IVehicleDetailsGridProps {
  vehicle: IVehicle
  className?: string
}

type Props = IVehicleDetailsGridProps

export const VehicleDetailsGrid: React.FC<Props> = ({ vehicle, className }) => {
  const { t } = useTranslation()

  const translateFuelTypes = (fuelTypes: FuelType[]) => fuelTypes?.map(fuelType => t(`Enum.EnumFuelType_${fuelType}`))

  return (
    <Table celled collapsing className={className} data-testid='vehicle-details-grid'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan={4}>
            <Header className='mt0'>
              <VehicleMakeImage manufacturer={vehicle.Manufacturer} size='massive' />
              <Header.Content>
                {vehicle.Manufacturer}
                <Header.Subheader>
                  {vehicle.Model} {vehicle.Type}
                </Header.Subheader>
              </Header.Content>
            </Header>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>{t('vehicle.vin')}</Table.Cell>
          <Table.Cell colSpan={3}>
            <VinText value={vehicle.Vin} />
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('vehicle.construction_year')}</Table.Cell>
          <Table.Cell>
            <strong>{vehicle.ConstructionYear}</strong>
          </Table.Cell>
          <Table.Cell>{t('vehicle.colour')}</Table.Cell>
          <Table.Cell>
            <strong>{vehicle.Colour}</strong>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('vehicle.fuel_types')}</Table.Cell>
          <Table.Cell>
            <strong>{translateFuelTypes(vehicle.FuelTypes)}</strong>
          </Table.Cell>
          <Table.Cell>{t('entities.vehicle.powerkw')}</Table.Cell>
          <Table.Cell>
            <strong>{vehicle.PowerKw}</strong>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t('vehicle.motor_code')}</Table.Cell>
          <Table.Cell>
            <strong>{vehicle.EngineCode}</strong>
          </Table.Cell>
          <Table.Cell>{t('vehicle.cylinders')}</Table.Cell>
          <Table.Cell>
            <strong>{vehicle.Cylinders}</strong>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

VehicleDetailsGrid.displayName = 'VehicleDetailsGrid'
export default VehicleDetailsGrid
